import React, { forwardRef } from "react";
import { personalDetails } from "../Details";
import gsap from "gsap";
import TypeWriterEffect from "react-typewriter-effect";

export const Home = forwardRef((props, ref) => {
  const { name, tagline, img } = personalDetails;
  const h11 = React.useRef();
  const h12 = React.useRef();
  const h13 = React.useRef();
  const myimageref = React.useRef();

  const downloadFile2 = () => {
    window.open("https://drive.google.com/file/d/1HDX6MAhrcRFkI7PFfmJG8XjIBhU2zUTp/view?usp=sharing", "_blank")
  };

  React.useEffect(() => {
    const tl = gsap.timeline();
    tl.from(h11.current, { x: "-100%", delay: 0.8, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(h12.current,
        { x: "-100%", delay: 0.5, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(
        h13.current,
        { x: "-100%", delay: 0.1, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(
        myimageref.current,
        { x: "200%", delay: 0.5, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<");
  }, []);

  return (
    <main ref={ref} id="home" className="container mx-auto max-width md:flex justify-evenly items-center pt-[7vw]">
      <div>
        <h1 ref={h11} className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >Hi,👋<br></br>My Name is<br></br></h1>
        <h1 ref={h12} className="text-2xl bg-clip-text bg-gradient text-transparent md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >{name}</h1>
        <h2 ref={h13} className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">{tagline}</h2>
        <h1 className="title">
          <TypeWriterEffect
            textStyle={{ fontFamily: "Red Hat Display", color: "#FFED00", fontWeight: "bold", fontSize: "1.5em" }}
            startDelay={3000}
            cursorColor="#865DFF"
            multiText={["Full Stack Web Developer", "Frontened Developer", "Backened Developer", "Problem Solver"]}
            multiTextDelay={2000}
            typeSpeed={100}
            multiTextLoop
          />
        </h1>
        <a href="https://drive.google.com/uc?export=download&id=1HDX6MAhrcRFkI7PFfmJG8XjIBhU2zUTp" id="resume-link-2">
          <button id="resume-button-2" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-2" onClick={downloadFile2}>Download Resume </button>
        </a>
      </div>
      <div className="mt-5 md:mt-0">
        <img ref={myimageref} className="w-auto h-[250px] rounded-full" src={img} alt="Ritik Singh" />
      </div>
    </main>
  )
});
